// ============================================================
// Teachers Mock Data
// ============================================================
// References existing schoolId values from mock/schools.js

export const mockTeachers = [
  // ── School 1 Teachers ─────────────────────────────────────
  {
    id: 'teacher-1',
    schoolId: 'school-1',
    userId: 'user-teacher-1',
    employeeId: 'EMP-GV-001',
    photo: null,
    firstName: 'Rajesh',
    lastName: 'Sharma',
    gender: 'Male',
    dateOfBirth: '1985-03-15',
    bloodGroup: 'B+',
    department: 'Mathematics',
    designation: 'Senior Teacher',
    qualification: 'M.Sc. Mathematics, B.Ed.',
    experience: '12 years',
    joiningDate: '2014-06-10',
    employmentType: 'Permanent',
    phone: '+91 98765 43210',
    email: 'rajesh.sharma@greenvalley.edu',
    address: '45 Teachers Colony, Green Valley Road, Delhi 110001',
    emergencyContact: '+91 98765 43211',
    aadhaar: '1234-5678-9012',
    pan: 'ABCDE1234F',
    certificates: ['B.Ed. Certificate', 'M.Sc. Degree'],
    resume: 'rajesh_sharma_resume.pdf',
    appointmentLetter: 'rajesh_sharma_appointment.pdf',
    bankDetails: {
      accountHolder: 'Rajesh Sharma',
      bankName: 'State Bank of India',
      accountNumber: '1234567890123456',
      ifsc: 'SBIN0001234',
    },
    status: 'active',
  },
  {
    id: 'teacher-2',
    schoolId: 'school-1',
    userId: 'user-teacher-2',
    employeeId: 'EMP-GV-002',
    photo: null,
    firstName: 'Priya',
    lastName: 'Patel',
    gender: 'Female',
    dateOfBirth: '1990-07-22',
    bloodGroup: 'A+',
    department: 'Science',
    designation: 'Teacher',
    qualification: 'M.Sc. Physics, B.Ed.',
    experience: '6 years',
    joiningDate: '2018-04-15',
    employmentType: 'Permanent',
    phone: '+91 87654 32109',
    email: 'priya.patel@greenvalley.edu',
    address: '12 Sunrise Apartments, Nehru Nagar, Delhi 110002',
    emergencyContact: '+91 87654 32110',
    aadhaar: '2345-6789-0123',
    pan: 'FGHIJ5678K',
    certificates: ['B.Ed. Certificate', 'M.Sc. Degree'],
    resume: 'priya_patel_resume.pdf',
    appointmentLetter: 'priya_patel_appointment.pdf',
    bankDetails: {
      accountHolder: 'Priya Patel',
      bankName: 'HDFC Bank',
      accountNumber: '2345678901234567',
      ifsc: 'HDFC0002345',
    },
    status: 'active',
  },
  {
    id: 'teacher-3',
    schoolId: 'school-1',
    userId: 'user-teacher-3',
    employeeId: 'EMP-GV-003',
    photo: null,
    firstName: 'Amit',
    lastName: 'Kumar',
    gender: 'Male',
    dateOfBirth: '1988-11-05',
    bloodGroup: 'O+',
    department: 'English',
    designation: 'Senior Teacher',
    qualification: 'M.A. English Literature, B.Ed.',
    experience: '10 years',
    joiningDate: '2016-07-01',
    employmentType: 'Permanent',
    phone: '+91 76543 21098',
    email: 'amit.kumar@greenvalley.edu',
    address: '78 Lake View Colony, Dwarka, Delhi 110075',
    emergencyContact: '+91 76543 21099',
    aadhaar: '3456-7890-1234',
    pan: 'KLMNO9012P',
    certificates: ['B.Ed. Certificate', 'M.A. Degree'],
    resume: 'amit_kumar_resume.pdf',
    appointmentLetter: 'amit_kumar_appointment.pdf',
    bankDetails: {
      accountHolder: 'Amit Kumar',
      bankName: 'ICICI Bank',
      accountNumber: '3456789012345678',
      ifsc: 'ICIC0003456',
    },
    status: 'active',
  },
  {
    id: 'teacher-4',
    schoolId: 'school-1',
    userId: null,
    employeeId: 'EMP-GV-004',
    photo: null,
    firstName: 'Sunita',
    lastName: 'Verma',
    gender: 'Female',
    dateOfBirth: '1982-01-18',
    bloodGroup: 'AB+',
    department: 'Hindi',
    designation: 'Head of Department',
    qualification: 'M.A. Hindi, Ph.D., B.Ed.',
    experience: '18 years',
    joiningDate: '2008-08-15',
    employmentType: 'Permanent',
    phone: '+91 65432 10987',
    email: 'sunita.verma@greenvalley.edu',
    address: '23 Gandhi Nagar, Saket, Delhi 110017',
    emergencyContact: '+91 65432 10988',
    aadhaar: '4567-8901-2345',
    pan: 'QRSTU3456V',
    certificates: ['Ph.D. Certificate', 'B.Ed. Certificate'],
    resume: 'sunita_verma_resume.pdf',
    appointmentLetter: 'sunita_verma_appointment.pdf',
    bankDetails: {
      accountHolder: 'Sunita Verma',
      bankName: 'Punjab National Bank',
      accountNumber: '4567890123456789',
      ifsc: 'PUNB0004567',
    },
    status: 'active',
  },
  {
    id: 'teacher-5',
    schoolId: 'school-1',
    userId: null,
    employeeId: 'EMP-GV-005',
    photo: null,
    firstName: 'Vikram',
    lastName: 'Singh',
    gender: 'Male',
    dateOfBirth: '1992-09-30',
    bloodGroup: 'B-',
    department: 'Social Science',
    designation: 'Teacher',
    qualification: 'M.A. History, B.Ed.',
    experience: '4 years',
    joiningDate: '2020-01-10',
    employmentType: 'Contractual',
    phone: '+91 54321 09876',
    email: 'vikram.singh@greenvalley.edu',
    address: '56 Rajendra Place, Delhi 110008',
    emergencyContact: '+91 54321 09877',
    aadhaar: '5678-9012-3456',
    pan: 'WXYZ7890A',
    certificates: ['B.Ed. Certificate', 'M.A. Degree'],
    resume: 'vikram_singh_resume.pdf',
    appointmentLetter: 'vikram_singh_appointment.pdf',
    bankDetails: {
      accountHolder: 'Vikram Singh',
      bankName: 'Bank of Baroda',
      accountNumber: '5678901234567890',
      ifsc: 'BARB0005678',
    },
    status: 'active',
  },
  {
    id: 'teacher-6',
    schoolId: 'school-1',
    userId: null,
    employeeId: 'EMP-GV-006',
    photo: null,
    firstName: 'Neha',
    lastName: 'Gupta',
    gender: 'Female',
    dateOfBirth: '1995-04-12',
    bloodGroup: 'A-',
    department: 'Computer Science',
    designation: 'Teacher',
    qualification: 'M.Tech. Computer Science, B.Ed.',
    experience: '3 years',
    joiningDate: '2021-06-20',
    employmentType: 'Permanent',
    phone: '+91 43210 98765',
    email: 'neha.gupta@greenvalley.edu',
    address: '90 IT Park Road, Noida 201301',
    emergencyContact: '+91 43210 98766',
    aadhaar: '6789-0123-4567',
    pan: 'BCDEF1234G',
    certificates: ['M.Tech. Degree', 'B.Ed. Certificate'],
    resume: 'neha_gupta_resume.pdf',
    appointmentLetter: 'neha_gupta_appointment.pdf',
    bankDetails: {
      accountHolder: 'Neha Gupta',
      bankName: 'Axis Bank',
      accountNumber: '6789012345678901',
      ifsc: 'UTIB0006789',
    },
    status: 'active',
  },
  {
    id: 'teacher-7',
    schoolId: 'school-1',
    userId: null,
    employeeId: 'EMP-GV-007',
    photo: null,
    firstName: 'Ramesh',
    lastName: 'Nair',
    gender: 'Male',
    dateOfBirth: '1978-12-25',
    bloodGroup: 'O-',
    department: 'Physical Education',
    designation: 'Sports Instructor',
    qualification: 'M.P.Ed.',
    experience: '20 years',
    joiningDate: '2006-03-01',
    employmentType: 'Permanent',
    phone: '+91 32109 87654',
    email: 'ramesh.nair@greenvalley.edu',
    address: '34 Sports Complex, RK Puram, Delhi 110066',
    emergencyContact: '+91 32109 87655',
    aadhaar: '7890-1234-5678',
    pan: 'HIJKL5678M',
    certificates: ['M.P.Ed. Degree', 'NIS Certificate'],
    resume: 'ramesh_nair_resume.pdf',
    appointmentLetter: 'ramesh_nair_appointment.pdf',
    bankDetails: {
      accountHolder: 'Ramesh Nair',
      bankName: 'Canara Bank',
      accountNumber: '7890123456789012',
      ifsc: 'CNRB0007890',
    },
    status: 'active',
  },
  {
    id: 'teacher-8',
    schoolId: 'school-1',
    userId: null,
    employeeId: 'EMP-GV-008',
    photo: null,
    firstName: 'Kavita',
    lastName: 'Reddy',
    gender: 'Female',
    dateOfBirth: '1987-06-14',
    bloodGroup: 'B+',
    department: 'Science',
    designation: 'Teacher',
    qualification: 'M.Sc. Chemistry, B.Ed.',
    experience: '8 years',
    joiningDate: '2017-01-15',
    employmentType: 'Permanent',
    phone: '+91 21098 76543',
    email: 'kavita.reddy@greenvalley.edu',
    address: '67 Jubilee Hills, Hyderabad Road, Delhi 110025',
    emergencyContact: '+91 21098 76544',
    aadhaar: '8901-2345-6789',
    pan: 'NOPQR9012S',
    certificates: ['M.Sc. Degree', 'B.Ed. Certificate'],
    resume: 'kavita_reddy_resume.pdf',
    appointmentLetter: 'kavita_reddy_appointment.pdf',
    bankDetails: {
      accountHolder: 'Kavita Reddy',
      bankName: 'Union Bank of India',
      accountNumber: '8901234567890123',
      ifsc: 'UBIN0008901',
    },
    status: 'inactive',
  },
  // ── School 2 Teachers ─────────────────────────────────────
  {
    id: 'teacher-9',
    schoolId: 'school-2',
    userId: null,
    employeeId: 'EMP-LK-001',
    photo: null,
    firstName: 'Anand',
    lastName: 'Mishra',
    gender: 'Male',
    dateOfBirth: '1983-08-20',
    bloodGroup: 'A+',
    department: 'Mathematics',
    designation: 'Head of Department',
    qualification: 'M.Sc. Mathematics, Ph.D.',
    experience: '15 years',
    joiningDate: '2011-04-01',
    employmentType: 'Permanent',
    phone: '+91 99887 76655',
    email: 'anand.mishra@school2.edu',
    address: '12 University Road, Lucknow 226001',
    emergencyContact: '+91 99887 76656',
    aadhaar: '9012-3456-7890',
    pan: 'TUVWX3456Y',
    certificates: ['Ph.D. Certificate', 'M.Sc. Degree'],
    resume: 'anand_mishra_resume.pdf',
    appointmentLetter: 'anand_mishra_appointment.pdf',
    bankDetails: {
      accountHolder: 'Anand Mishra',
      bankName: 'State Bank of India',
      accountNumber: '9012345678901234',
      ifsc: 'SBIN0009012',
    },
    status: 'active',
  },
  {
    id: 'teacher-10',
    schoolId: 'school-2',
    userId: null,
    employeeId: 'EMP-LK-002',
    photo: null,
    firstName: 'Meera',
    lastName: 'Das',
    gender: 'Female',
    dateOfBirth: '1991-02-28',
    bloodGroup: 'O+',
    department: 'English',
    designation: 'Teacher',
    qualification: 'M.A. English, B.Ed.',
    experience: '5 years',
    joiningDate: '2019-07-15',
    employmentType: 'Permanent',
    phone: '+91 88776 65544',
    email: 'meera.das@school2.edu',
    address: '45 Gomti Nagar, Lucknow 226010',
    emergencyContact: '+91 88776 65545',
    aadhaar: '0123-4567-8901',
    pan: 'ZABCD7890E',
    certificates: ['M.A. Degree', 'B.Ed. Certificate'],
    resume: 'meera_das_resume.pdf',
    appointmentLetter: 'meera_das_appointment.pdf',
    bankDetails: {
      accountHolder: 'Meera Das',
      bankName: 'HDFC Bank',
      accountNumber: '0123456789012345',
      ifsc: 'HDFC0000123',
    },
    status: 'active',
  },
  // ── School 4 Teachers ─────────────────────────────────────
  {
    id: 'teacher-11',
    schoolId: 'school-4',
    userId: null,
    employeeId: 'EMP-BG-001',
    photo: null,
    firstName: 'Deepak',
    lastName: 'Rao',
    gender: 'Male',
    dateOfBirth: '1986-05-10',
    bloodGroup: 'AB+',
    department: 'Science',
    designation: 'Senior Teacher',
    qualification: 'M.Sc. Biology, B.Ed.',
    experience: '11 years',
    joiningDate: '2015-03-20',
    employmentType: 'Permanent',
    phone: '+91 77665 54433',
    email: 'deepak.rao@school4.edu',
    address: '23 Koramangala, Bangalore 560034',
    emergencyContact: '+91 77665 54434',
    aadhaar: '1111-2222-3333',
    pan: 'EFGHI1234J',
    certificates: ['M.Sc. Degree', 'B.Ed. Certificate'],
    resume: 'deepak_rao_resume.pdf',
    appointmentLetter: 'deepak_rao_appointment.pdf',
    bankDetails: {
      accountHolder: 'Deepak Rao',
      bankName: 'Kotak Mahindra Bank',
      accountNumber: '1111222233334444',
      ifsc: 'KKBK0001111',
    },
    status: 'active',
  },
  {
    id: 'teacher-12',
    schoolId: 'school-5',
    userId: null,
    employeeId: 'EMP-MB-001',
    photo: null,
    firstName: 'Shalini',
    lastName: 'Bose',
    gender: 'Female',
    dateOfBirth: '1989-10-08',
    bloodGroup: 'A+',
    department: 'Mathematics',
    designation: 'Teacher',
    qualification: 'M.Sc. Mathematics, B.Ed.',
    experience: '7 years',
    joiningDate: '2018-01-10',
    employmentType: 'Permanent',
    phone: '+91 66554 43322',
    email: 'shalini.bose@school5.edu',
    address: '56 Bandra West, Mumbai 400050',
    emergencyContact: '+91 66554 43323',
    aadhaar: '4444-5555-6666',
    pan: 'KLMNO5678P',
    certificates: ['M.Sc. Degree', 'B.Ed. Certificate'],
    resume: 'shalini_bose_resume.pdf',
    appointmentLetter: 'shalini_bose_appointment.pdf',
    bankDetails: {
      accountHolder: 'Shalini Bose',
      bankName: 'Bank of Maharashtra',
      accountNumber: '4444555566667777',
      ifsc: 'MAHB0004444',
    },
    status: 'active',
  },
];

// Departments and Designations for filters/forms
export const DEPARTMENTS = [
  'Mathematics',
  'Science',
  'English',
  'Hindi',
  'Social Science',
  'Computer Science',
  'Physical Education',
  'Art & Craft',
  'Music',
];

export const DESIGNATIONS = [
  'Head of Department',
  'Senior Teacher',
  'Teacher',
  'Junior Teacher',
  'Sports Instructor',
  'Lab Assistant',
];

export const EMPLOYMENT_TYPES = ['Permanent', 'Contractual', 'Part-Time', 'Visiting'];

export const SUBJECTS = [
  'Mathematics',
  'Physics',
  'Chemistry',
  'Biology',
  'English',
  'Hindi',
  'History',
  'Geography',
  'Civics',
  'Computer Science',
  'Physical Education',
  'Art & Craft',
  'Music',
  'Environmental Science',
  'General Knowledge',
];
